import React from 'react';
import AppInputNumber from '../../../../ui/AppInputNumber';

let edit = false;

const initialForm = {
  residencialMono: {
    key: 'residencialMono',
    value: '',
    required: false,
  },
  residencialBi: {
    key: 'residencialBi',
    value: '',
    required: false,
  },
  residencialTri: {
    key: 'residencialTri',
    value: '',
    required: false,
  },
  comercialMono: {
    key: 'comercialMono',
    value: '',
    required: false,
  },
  comercialBi: {
    key: 'comercialBi',
    value: '',
    required: false,
  },
  comercialTri: {
    key: 'comercialTri',
    value: '',
    required: false,
  },
  industrialMono: {
    key: 'industrialMono',
    value: '',
    required: false,
  },
  industrialBi: {
    key: 'industrialBi',
    value: '',
    required: false,
  },
  industrialTri: {
    key: 'industrialTri',
    value: '',
    required: false,
  },
  oficialMono: {
    key: 'oficialMono',
    value: '',
    required: false,
  },
  oficialBi: {
    key: 'oficialBi',
    value: '',
    required: false,
  },
  oficialTri: {
    key: 'oficialTri',
    value: '',
    required: false,
  },
  alumbradoMono: {
    key: 'alumbradoMono',
    value: '',
    required: false,
  },
  alumbradoBi: {
    key: 'alumbradoBi',
    value: '',
    required: false,
  },
  alumbradoTri: {
    key: 'alumbradoTri',
    value: '',
    required: false,
  },
  provisionalMono: {
    key: 'provisionalMono',
    value: '',
    required: false,
  },
  provisionalBi: {
    key: 'provisionalBi',
    value: '',
    required: false,
  },
  provisionalTri: {
    key: 'provisionalTri',
    value: '',
    required: false,
  },
  integradorMono: {
    key: 'integradorMono',
    value: '',
    required: false,
  },
  integradorBi: {
    key: 'integradorBi',
    value: '',
    required: false,
  },
  integradorTri: {
    key: 'integradorTri',
    value: '',
    required: false,
  },
};

class TableCuentaTipo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: initialForm,
      totalMono: 0,
      totalBi: 0,
      totalTri: 0,
    };
  }

  async componentDidMount() {}

  handleChange = async (e) => {
    const { value, name } = e.target;

    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: value,
          },
        },
      };
    });

    if (name.includes('Mono')) {
      const total = this.calcularTotal('Mono', name) + this.stringToZero(value);
      this.setState({ totalMono: total });
    }
    if (name.includes('Bi')) {
      const total = this.calcularTotal('Bi', name) + this.stringToZero(value);
      this.setState({ totalBi: total });
    }
    if (name.includes('Tri')) {
      const total = this.calcularTotal('Tri', name) + this.stringToZero(value);
      this.setState({ totalTri: total });
    }

    const data = JSON.stringify(this.state);
    this.props.onSetRegistrocuentatipo(data);
  };

  calcularTotal(tipo, name) {
    const items = ['residencial', 'comercial', 'industrial', 'oficial', 'alumbrado', 'provisional', 'integrador'];
    let total = 0;
    items.forEach((b) => {
      if (name !== b + tipo) {
        total += this.stringToZero(this.state.form[b + tipo].value);
      }
    });

    return total;
  }

  stringToZero(value) {
    return value === '' ? 0 : parseInt(value);
  }

  loadData = () => {
    if (edit) {
      return;
    }
    if (this.props.data) {
      const data = JSON.parse(this.props.data);

      initialForm.residencialMono.value = data.form.residencialMono.value;
      initialForm.residencialBi.value = data.form.residencialBi.value;
      initialForm.residencialTri.value = data.form.residencialTri.value;

      initialForm.comercialMono.value = data.form.comercialMono.value;
      initialForm.comercialBi.value = data.form.comercialBi.value;
      initialForm.comercialTri.value = data.form.comercialTri.value;

      initialForm.industrialMono.value = data.form.industrialMono.value;
      initialForm.industrialBi.value = data.form.industrialBi.value;
      initialForm.industrialTri.value = data.form.industrialTri.value;

      initialForm.oficialMono.value = data.form.oficialMono.value;
      initialForm.oficialBi.value = data.form.oficialBi.value;
      initialForm.oficialTri.value = data.form.oficialTri.value;

      initialForm.alumbradoMono.value = data.form.alumbradoMono.value;
      initialForm.alumbradoBi.value = data.form.alumbradoBi.value;
      initialForm.alumbradoTri.value = data.form.alumbradoTri.value;

      initialForm.provisionalMono.value = data.form.provisionalMono.value;
      initialForm.provisionalBi.value = data.form.provisionalBi.value;
      initialForm.provisionalTri.value = data.form.provisionalTri.value;

      initialForm.integradorMono.value = data.form.integradorMono?.value || '';
      initialForm.integradorBi.value = data.form.integradorBi?.value || '';
      initialForm.integradorTri.value = data.form.integradorTri?.value || '';

      edit = true;
    }
  };

  render() {
    this.loadData();
    return (
      <table className="custom-table">
        <thead>
          <tr>
            <th>Tipo de Carga</th>
            <th>Monofásicas</th>
            <th>Bifásicas</th>
            <th>Trifásicas</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Residenciales</td>
            <td>
              <AppInputNumber
                id={this.state.form.residencialMono.key}
                name={this.state.form.residencialMono.key}
                value={this.state.form.residencialMono.value}
                // value={this.state.form.residencialMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.residencialBi.key}
                name={this.state.form.residencialBi.key}
                value={this.state.form.residencialBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.residencialTri.key}
                name={this.state.form.residencialTri.key}
                value={this.state.form.residencialTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>
          <tr>
            <td>Comerciales</td>
            <td>
              <AppInputNumber
                id={this.state.form.comercialMono.key}
                name={this.state.form.comercialMono.key}
                value={this.state.form.comercialMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.comercialBi.key}
                name={this.state.form.comercialBi.key}
                value={this.state.form.comercialBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.comercialTri.key}
                name={this.state.form.comercialTri.key}
                value={this.state.form.comercialTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>
          <tr>
            <td>Industriales</td>
            <td>
              <AppInputNumber
                id={this.state.form.industrialMono.key}
                name={this.state.form.industrialMono.key}
                value={this.state.form.industrialMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.industrialBi.key}
                name={this.state.form.industrialBi.key}
                value={this.state.form.industrialBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.industrialTri.key}
                name={this.state.form.industrialTri.key}
                value={this.state.form.industrialTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>
          <tr>
            <td>Oficiales</td>
            <td>
              <AppInputNumber
                id={this.state.form.oficialMono.key}
                name={this.state.form.oficialMono.key}
                value={this.state.form.oficialMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.oficialBi.key}
                name={this.state.form.oficialBi.key}
                value={this.state.form.oficialBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.oficialTri.key}
                name={this.state.form.oficialTri.key}
                value={this.state.form.oficialTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>
          <tr>
            <td>Alumbrado público</td>
            <td>
              <AppInputNumber
                id={this.state.form.alumbradoMono.key}
                name={this.state.form.alumbradoMono.key}
                value={this.state.form.alumbradoMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.alumbradoBi.key}
                name={this.state.form.alumbradoBi.key}
                value={this.state.form.alumbradoBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.alumbradoTri.key}
                name={this.state.form.alumbradoTri.key}
                value={this.state.form.alumbradoTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>
          <tr>
            <td>Provisional Obra</td>
            <td>
              <AppInputNumber
                id={this.state.form.provisionalMono.key}
                name={this.state.form.provisionalMono.key}
                value={this.state.form.provisionalMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.provisionalBi.key}
                name={this.state.form.provisionalBi.key}
                value={this.state.form.provisionalBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.provisionalTri.key}
                name={this.state.form.provisionalTri.key}
                value={this.state.form.provisionalTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>

          <tr>
            <td>Integrador</td>
            <td>
              <AppInputNumber
                id={this.state.form.integradorMono.key}
                name={this.state.form.integradorMono.key}
                value={this.state.form.integradorMono.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.integradorBi.key}
                name={this.state.form.integradorBi.key}
                value={this.state.form.integradorBi.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
            <td>
              {' '}
              <AppInputNumber
                id={this.state.form.integradorTri.key}
                name={this.state.form.integradorTri.key}
                value={this.state.form.integradorTri.value}
                onChange={this.handleChange}
                disabled={this.props.disabled}
              />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>Total por clase de carga</th>
            <th>{this.state.totalMono}</th>
            <th>{this.state.totalBi}</th>
            <th>{this.state.totalTri}</th>
          </tr>
          <tr>
            <th>Número total de cuentas</th>
            <th>{this.state.totalMono + this.state.totalBi + this.state.totalTri}</th>
          </tr>
        </tfoot>
      </table>
    );
  }
}

export default TableCuentaTipo;
